import React, { useState, useCallback } from "react";
import TextField from "../../UI/Inputs/TextField.js";
import Button from "../../UI/Buttons/Button.js";
import { DndProvider, useDrag, useDrop } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus,faArrows,faTrash } from "@fortawesome/free-solid-svg-icons";

const NewBlankOption = ({ onAdd }) => {
  return (
    <Button
      handler={onAdd}
      label={
        <div className="">
          Add Option <FontAwesomeIcon icon={faPlus} />
        </div>
      }
      className="w-full bg-gray-100 md:w-[250px] p-1 rounded-md text-center hover:font-semibold hover:bg-gray-200 cursor-pointer active:scale-95"
    />
  );
};

const OptionItem = ({
  option,
  index,
  moveOption,
  handleOptionChange,
  handleDeleteOption,
}) => {
  const [, drag] = useDrag({
    type: "OPTION",
    item: { index },
  });

  const [, drop] = useDrop({
    accept: "OPTION",
    hover: (draggedItem) => {
      if (draggedItem.index !== index) {
        moveOption(draggedItem.index, index);
        draggedItem.index = index;
      }
    },
  });

  return (
    <div
      ref={(node) => drag(drop(node))}
      className=" flex items-center mb-2 gap-2 border-[1px] pb-2  px-2"
    >
      <div className="relative w-full ">
        <TextField
          icon={<FontAwesomeIcon icon={faArrows} />
}
          value={option.name}
          label={`Option ${option.order}`}
          placeholder={`Option ${option.order}`}
          name={`option-${option.order}`}
          onValueChange={(_, value) => handleOptionChange(index, value)}
        />
        <button
          onClick={() => handleDeleteOption(index)}
          className="absolute top-[calc(50%-5px)] right-0 px-2 py-2  rounded hover:bg-red-200 cursor-pointer"
        >
          <FontAwesomeIcon icon={faTrash} className="text-red-500" />

        </button>
      </div>
    </div>
  );
};

const ManageOptions = ({ data, setter }) => {
  const [questionOptions, setQuestionOptions] = useState(
    data.questionOptions || []
  );

  const handleOptionChange = (index, value) => {
    const newOptions = [...questionOptions];
    newOptions[index] = { ...newOptions[index], name: value };
    updateOptions(newOptions);
  };

  const handleAddOption = () => {
    const newOption = { name: "", order: questionOptions.length + 1 };
    updateOptions([...questionOptions, newOption]);
  };

  const handleDeleteOption = (index) => {
    const newOptions = questionOptions
      .filter((_, i) => i !== index)
      .map((option, i) => ({ ...option, order: i + 1 }));
    updateOptions(newOptions);
  };

  const updateOptions = useCallback(
    (newOptions) => {
      setQuestionOptions(newOptions);
      setter({ ...data, questionOptions: newOptions });
    },
    [setter, data]
  );

  const moveOption = useCallback(
    (dragIndex, hoverIndex) => {
      const draggedOption = questionOptions[dragIndex];
      const newOptions = [...questionOptions];
      newOptions.splice(dragIndex, 1);
      newOptions.splice(hoverIndex, 0, draggedOption);
      const updatedOptions = newOptions.map((option, index) => ({
        ...option,
        order: index + 1,
      }));
      updateOptions(updatedOptions);
    },
    [questionOptions, updateOptions]
  );


  return (
    <DndProvider backend={HTML5Backend}>
      <div className="border-gray-300 border-2 p-4 rounded-md">
        <p className="text-lg mb-4">Manage Options</p>
        {questionOptions.map((option, index) => (
          <OptionItem
            key={index}
            option={option}
            index={index}
            moveOption={moveOption}
            handleOptionChange={handleOptionChange}
            handleDeleteOption={handleDeleteOption}
          />
        ))}
        <NewBlankOption onAdd={handleAddOption} />
      </div>
    </DndProvider>
  );
};

export default ManageOptions;
